import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticlePolska() {
  return <ArticleTemplate article={articles[3]} />;
}